/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  AuthDetail,
  AuthEmailRequest,
  AuthLinkTokenRequest,
  AuthLoginRequest,
  AuthMagicLinkRequest,
  AuthPasswordChangeCreate400,
  AuthPasswordChangeRequest,
  AuthPasswordResetConfirmCreate400,
  AuthPasswordResetConfirmRequest,
  AuthPasswordSetCreate400,
  AuthPasswordSetRequest,
  AuthRefreshRefused,
  AuthRefreshRequest,
  AuthTokenPair
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type authLoginCreateResponse200 = {
  data: AuthTokenPair
  status: 200
}

export type authLoginCreateResponse401 = {
  data: AuthDetail
  status: 401
}

export type authLoginCreateResponseSuccess = (authLoginCreateResponse200) & {
  headers: Headers;
};
export type authLoginCreateResponseError = (authLoginCreateResponse401) & {
  headers: Headers;
};

export type authLoginCreateResponse = (authLoginCreateResponseSuccess | authLoginCreateResponseError)

export const getAuthLoginCreateUrl = () => {




  return `/api/v1/auth/login/`
}

export const authLoginCreate = async (authLoginRequest: AuthLoginRequest, options?: RequestInit): Promise<authLoginCreateResponse> => {

  return customFetch<authLoginCreateResponse>(getAuthLoginCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authLoginRequest)
  }
);}


export type authLogoutCreateResponse204 = {
  data: void
  status: 204
}

export type authLogoutCreateResponseSuccess = (authLogoutCreateResponse204) & {
  headers: Headers;
};
;

export type authLogoutCreateResponse = (authLogoutCreateResponseSuccess)

export const getAuthLogoutCreateUrl = () => {




  return `/api/v1/auth/logout/`
}

export const authLogoutCreate = async (authRefreshRequest: AuthRefreshRequest, options?: RequestInit): Promise<authLogoutCreateResponse> => {

  return customFetch<authLogoutCreateResponse>(getAuthLogoutCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authRefreshRequest)
  }
);}


export type authMagicLinkCreateResponse202 = {
  data: AuthDetail
  status: 202
}

export type authMagicLinkCreateResponseSuccess = (authMagicLinkCreateResponse202) & {
  headers: Headers;
};
;

export type authMagicLinkCreateResponse = (authMagicLinkCreateResponseSuccess)

export const getAuthMagicLinkCreateUrl = () => {




  return `/api/v1/auth/magic-link/`
}

export const authMagicLinkCreate = async (authMagicLinkRequest: AuthMagicLinkRequest, options?: RequestInit): Promise<authMagicLinkCreateResponse> => {

  return customFetch<authMagicLinkCreateResponse>(getAuthMagicLinkCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authMagicLinkRequest)
  }
);}


export type authMagicLinkConsumeCreateResponse200 = {
  data: AuthTokenPair
  status: 200
}

export type authMagicLinkConsumeCreateResponse401 = {
  data: AuthDetail
  status: 401
}

export type authMagicLinkConsumeCreateResponseSuccess = (authMagicLinkConsumeCreateResponse200) & {
  headers: Headers;
};
export type authMagicLinkConsumeCreateResponseError = (authMagicLinkConsumeCreateResponse401) & {
  headers: Headers;
};

export type authMagicLinkConsumeCreateResponse = (authMagicLinkConsumeCreateResponseSuccess | authMagicLinkConsumeCreateResponseError)

export const getAuthMagicLinkConsumeCreateUrl = () => {




  return `/api/v1/auth/magic-link/consume/`
}

export const authMagicLinkConsumeCreate = async (authLinkTokenRequest: AuthLinkTokenRequest, options?: RequestInit): Promise<authMagicLinkConsumeCreateResponse> => {

  return customFetch<authMagicLinkConsumeCreateResponse>(getAuthMagicLinkConsumeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authLinkTokenRequest)
  }
);}


export type authPasswordChangeCreateResponse204 = {
  data: void
  status: 204
}

export type authPasswordChangeCreateResponse400 = {
  data: AuthPasswordChangeCreate400
  status: 400
}

export type authPasswordChangeCreateResponse403 = {
  data: AuthDetail
  status: 403
}

export type authPasswordChangeCreateResponseSuccess = (authPasswordChangeCreateResponse204) & {
  headers: Headers;
};
export type authPasswordChangeCreateResponseError = (authPasswordChangeCreateResponse400 | authPasswordChangeCreateResponse403) & {
  headers: Headers;
};

export type authPasswordChangeCreateResponse = (authPasswordChangeCreateResponseSuccess | authPasswordChangeCreateResponseError)

export const getAuthPasswordChangeCreateUrl = () => {




  return `/api/v1/auth/password/change/`
}

export const authPasswordChangeCreate = async (authPasswordChangeRequest: AuthPasswordChangeRequest, options?: RequestInit): Promise<authPasswordChangeCreateResponse> => {

  return customFetch<authPasswordChangeCreateResponse>(getAuthPasswordChangeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authPasswordChangeRequest)
  }
);}


export type authPasswordResetCreateResponse202 = {
  data: AuthDetail
  status: 202
}

export type authPasswordResetCreateResponseSuccess = (authPasswordResetCreateResponse202) & {
  headers: Headers;
};
;

export type authPasswordResetCreateResponse = (authPasswordResetCreateResponseSuccess)

export const getAuthPasswordResetCreateUrl = () => {




  return `/api/v1/auth/password/reset/`
}

export const authPasswordResetCreate = async (authEmailRequest: AuthEmailRequest, options?: RequestInit): Promise<authPasswordResetCreateResponse> => {

  return customFetch<authPasswordResetCreateResponse>(getAuthPasswordResetCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authEmailRequest)
  }
);}


export type authPasswordResetConfirmCreateResponse200 = {
  data: AuthTokenPair
  status: 200
}

export type authPasswordResetConfirmCreateResponse400 = {
  data: AuthPasswordResetConfirmCreate400
  status: 400
}

export type authPasswordResetConfirmCreateResponse401 = {
  data: AuthDetail
  status: 401
}

export type authPasswordResetConfirmCreateResponseSuccess = (authPasswordResetConfirmCreateResponse200) & {
  headers: Headers;
};
export type authPasswordResetConfirmCreateResponseError = (authPasswordResetConfirmCreateResponse400 | authPasswordResetConfirmCreateResponse401) & {
  headers: Headers;
};

export type authPasswordResetConfirmCreateResponse = (authPasswordResetConfirmCreateResponseSuccess | authPasswordResetConfirmCreateResponseError)

export const getAuthPasswordResetConfirmCreateUrl = () => {




  return `/api/v1/auth/password/reset/confirm/`
}

/**
 * Sets the new password, ends every session and outstanding link for the account, and signs the user in with a new session.
 */
export const authPasswordResetConfirmCreate = async (authPasswordResetConfirmRequest: AuthPasswordResetConfirmRequest, options?: RequestInit): Promise<authPasswordResetConfirmCreateResponse> => {

  return customFetch<authPasswordResetConfirmCreateResponse>(getAuthPasswordResetConfirmCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authPasswordResetConfirmRequest)
  }
);}


export type authPasswordSetCreateResponse204 = {
  data: void
  status: 204
}

export type authPasswordSetCreateResponse400 = {
  data: AuthPasswordSetCreate400
  status: 400
}

export type authPasswordSetCreateResponse403 = {
  data: AuthDetail
  status: 403
}

export type authPasswordSetCreateResponseSuccess = (authPasswordSetCreateResponse204) & {
  headers: Headers;
};
export type authPasswordSetCreateResponseError = (authPasswordSetCreateResponse400 | authPasswordSetCreateResponse403) & {
  headers: Headers;
};

export type authPasswordSetCreateResponse = (authPasswordSetCreateResponseSuccess | authPasswordSetCreateResponseError)

export const getAuthPasswordSetCreateUrl = () => {




  return `/api/v1/auth/password/set/`
}

/**
 * Sets a password on the signed-in account when it has none. Only a LiftAI access token from the user's own sign-in (/auth/login/, /auth/magic-link/consume/ or /auth/password/reset/confirm/) is accepted. A session cookie, API key or impersonation session gets 403.
 */
export const authPasswordSetCreate = async (authPasswordSetRequest: AuthPasswordSetRequest, options?: RequestInit): Promise<authPasswordSetCreateResponse> => {

  return customFetch<authPasswordSetCreateResponse>(getAuthPasswordSetCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authPasswordSetRequest)
  }
);}


export type authRefreshCreateResponse200 = {
  data: AuthTokenPair
  status: 200
}

export type authRefreshCreateResponse401 = {
  data: AuthRefreshRefused
  status: 401
}

export type authRefreshCreateResponseSuccess = (authRefreshCreateResponse200) & {
  headers: Headers;
};
export type authRefreshCreateResponseError = (authRefreshCreateResponse401) & {
  headers: Headers;
};

export type authRefreshCreateResponse = (authRefreshCreateResponseSuccess | authRefreshCreateResponseError)

export const getAuthRefreshCreateUrl = () => {




  return `/api/v1/auth/refresh/`
}

export const authRefreshCreate = async (authRefreshRequest: AuthRefreshRequest, options?: RequestInit): Promise<authRefreshCreateResponse> => {

  return customFetch<authRefreshCreateResponse>(getAuthRefreshCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authRefreshRequest)
  }
);}


